/** @format */

import {
  HomefieldIconLibraryModule,
  HomefieldIconsLibraryService,
  homefieldIconSignCheckFill,
} from '@dsg-tech/homefield-angular-icons';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HomefieldCheckboxComponent } from './checkbox.component';

@NgModule({
  imports: [CommonModule, HomefieldIconLibraryModule],
  declarations: [HomefieldCheckboxComponent],
  exports: [HomefieldCheckboxComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class HomefieldCheckboxModule {
  constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
    homefieldIconsLibraryService.registerIcons([homefieldIconSignCheckFill]);
  }
}
